var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 303.17 89.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#fff;}.cls-4{clip-path:url(#clip-path-3);}.cls-5{clip-path:url(#clip-path-4);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0 -8.98)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 205.47,
    width: 109.3,
    height: 106.52
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3",
    transform: "translate(0 -8.98)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "OVAL_MAsk",
    "data-name": "OVAL MAsk",
    className: "cls-1",
    d: "M246.82,26c0,5.76,5.34,10.44,11.91,10.44S270.64,31.77,270.64,26v-.08a29.81,29.81,0,1,1-23.82,0V26"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4",
    transform: "translate(0 -8.98)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "TOP_PAGE_Mask",
    "data-name": "TOP PAGE Mask",
    className: "cls-1",
    d: "M257.79,36.82s4.5-1.66,7.48-1.66.49,3.61,3,3.61.48,7.4.48,7.4,4.58,6.6,4.58,6.6-.42.58-3,.58c-2.88,0-3.77-1.46-6.84-1.46a9.13,9.13,0,0,0-4.77,1.32,9.13,9.13,0,0,0-4.77-1.32c-3.07,0-4,1.46-6.84,1.46-2.62,0-3-.58-3-.58s.92-4.55.88-4.59.32-6.43,2.94-6.43,4-7.79,7-7.79A2.73,2.73,0,0,1,257.79,36.82Z"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "clark-logo-white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M276.53,29c.19.13.37.27.55.41-.18-.14-.36-.28-.55-.41",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M276,28.62c.2.14.39.27.57.41-.18-.14-.37-.27-.57-.41",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M268.66,24.89l.47.17-.47-.17",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M272.81,26.7l.72.4-.72-.4",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M277.1,29.46l.54.42-.54-.42",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M263.41,51.75a7.24,7.24,0,0,1,2,.26l-3.69-8.43c-.08.44-.15.86-.21,1.23a14.28,14.28,0,0,0,.81,7,9,9,0,0,1,1.05-.06",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M269.28,25.11l.52.2-.52-.2",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M251.79,52a7.16,7.16,0,0,1,2-.26,9.35,9.35,0,0,1,2.59.36c-.1-.43-.23-.86-.37-1.33a22.15,22.15,0,0,1-1-6.09Z",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M266.65,24.26l.42.12-.42-.12",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M280.61,55.85A10.18,10.18,0,0,0,277.52,54a16.39,16.39,0,0,1-5.85-4.07,14.12,14.12,0,0,1-2.52-4.44A20.07,20.07,0,0,0,267,41.3c-.36-.48-.8-1-1.27-1.51l2.75,13.28a6.54,6.54,0,0,0,1.43.15c2.38,0,2.86-.49,2.86-.49a.25.25,0,0,1,.28-.09.26.26,0,0,1,.16.25v1.34h.15a1.68,1.68,0,0,0,.8-.29.24.24,0,0,1,.26-.09.26.26,0,0,1,.19.24v1.28a3.76,3.76,0,0,0,.82-.29.28.28,0,0,1,.25,0,.25.25,0,0,1,.12.22v1.19h.67V78.11a30.59,30.59,0,0,0,9.89-12.19c-.2-.41-.41-.88-.64-1.38-1.36-2.94-3.21-7-5.09-8.69",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M268,24.67l.44.14-.44-.14",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M279.26,31.28l.49.48-.49-.48",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M279.76,31.77l.5.49-.5-.49",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M277.66,29.9l.52.43-.52-.43",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M278.73,30.81l.51.46-.51-.46",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M278.2,30.35l.52.45-.52-.45",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M281.67,33.8l.59.7-.59-.7",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M274.32,42.51a26.06,26.06,0,0,0,1.28,2.94A20.37,20.37,0,0,0,279.82,50a23.4,23.4,0,0,1,3.83,4,18.76,18.76,0,0,1,2,4.76c.05.18.1.34.15.49.58,1.85,1,3.64,1.27,5a30.54,30.54,0,0,0,1.54-15.46l-15.43-9c.46,1,.82,1.94,1.16,2.8",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M240.2,29.4c.38-.29.77-.57,1.17-.85-.4.28-.79.56-1.17.85",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M250.21,24.36l.39-.11-.39.11",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M253.05,23.69l.37-.06-.37.06",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M250.91,24.17l.38-.1-.38.1",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M248.83,24.79l.45-.14-.45.14",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M266,24.08l.4.1-.4-.1",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M251.62,24l.37-.08-.37.08",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M252.33,23.83l.37-.07-.37.07",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M249.51,24.57l.41-.13-.41.13",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M247.53,25.27c.42-.17.85-.33,1.29-.47-.44.14-.87.3-1.29.47",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M262.36,23.41l.37.05-.37-.05",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M261.62,23.33l.36,0-.36,0",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M253.78,23.56l.36,0-.36,0",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M260.88,23.27l.34,0-.34,0",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M263.1,23.51l.37.06-.37-.06",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M263.82,23.63l.39.07-.39-.07",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M265.25,23.91l.4.09-.4-.09",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M260.13,23.22l.31,0-.31,0",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M256,23.29l.33,0-.33,0",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M255.27,23.37l.34,0-.34,0",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M259.37,23.19h0",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M254.52,23.46l.35-.05-.35.05",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M256.79,23.24l.31,0-.31,0",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M257.6,23.2h0",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M239.63,29.85l.56-.45-.56.45",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M267.34,24.46l.42.13-.42-.13",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M264.54,23.76l.39.08-.39-.08",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M238,31.27l.54-.49-.54.49",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M237.46,31.77l.52-.5-.52.5",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M238.52,30.78c.36-.32.73-.63,1.1-.93-.37.3-.74.61-1.1.93",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M257.28,52.39a8.59,8.59,0,0,1,1.34.64l.44-.24c-.11-.8-.28-1.66-.46-2.54a24,24,0,0,1-.69-6.89c.28-2.57.42-5,.49-6.43l-2.59,5.9a21.06,21.06,0,0,0,1,7.73c.18.64.35,1.23.47,1.83",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M259.09,50.15c.17.84.33,1.65.44,2.41a10.14,10.14,0,0,1,2-.63,15.07,15.07,0,0,1-.81-7.25c.12-.69.27-1.53.43-2.41L258.89,37c-.07,1.49-.21,3.85-.48,6.39a23.42,23.42,0,0,0,.68,6.73",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M284.87,59A18,18,0,0,0,283,54.39a23.63,23.63,0,0,0-3.7-3.81,20.88,20.88,0,0,1-4.39-4.76,25.52,25.52,0,0,1-1.31-3c-.45-1.15-.95-2.41-1.64-3.8l-4.26-2.49a14.56,14.56,0,0,1,2.91,4c.37.8.7,1.64,1,2.45.87,2.22,1.68,4.32,3.34,5.79,1.07.95,2.33,1.89,3.53,2.8S281,53.44,282,54.35c1.24,1.11,2.46,3.84,3.43,6.35-.11-.41-.24-.83-.37-1.25,0-.16-.1-.32-.15-.5",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M281.63,54.72c-1-.9-2.18-1.79-3.44-2.74s-2.48-1.86-3.57-2.83c-1.75-1.55-2.62-3.8-3.47-6-.31-.81-.64-1.65-1-2.43a16.42,16.42,0,0,0-4.69-5.55l-.45-.26-.27.14.67,3.23a27.06,27.06,0,0,1,2.2,2.51,20.83,20.83,0,0,1,2.27,4.33,13.6,13.6,0,0,0,2.36,4.2,15.71,15.71,0,0,0,5.6,3.9,10.81,10.81,0,0,1,3.31,2c1.47,1.35,2.87,3.93,4.07,6.39-1-2.63-2.32-5.79-3.59-6.94",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M252.5,35l-.2-.11-.81.48a16.09,16.09,0,0,0-4.43,5.34c-.36.78-.68,1.62-1,2.42-.85,2.18-1.72,4.43-3.47,6-1.09,1-2.35,1.91-3.57,2.83s-2.45,1.84-3.44,2.74C234.31,55.87,233,59,232,61.65c1.2-2.46,2.61-5,4.07-6.38a10.81,10.81,0,0,1,3.31-2,15.71,15.71,0,0,0,5.6-3.9,13.48,13.48,0,0,0,2.36-4.2,20.83,20.83,0,0,1,2.27-4.33,28,28,0,0,1,2.24-2.55Z",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M235.25,54.35c1-.91,2.2-1.81,3.48-2.77s2.46-1.85,3.53-2.8c1.66-1.47,2.47-3.57,3.34-5.79.31-.81.64-1.65,1-2.45a14.35,14.35,0,0,1,2.78-3.9l-4.17,2.43c-.67,1.37-1.16,2.61-1.59,3.73a27.24,27.24,0,0,1-1.32,3,20.88,20.88,0,0,1-4.39,4.76,23.63,23.63,0,0,0-3.7,3.81A18,18,0,0,0,232.34,59c-.05.18-.1.35-.15.5-.13.42-.26.84-.37,1.25,1-2.51,2.2-5.24,3.43-6.35",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M241,30.62l1.9-.8c.67-.27,1.31-.5,1.91-.69l-3.44-.58h0c-.4.28-.79.56-1.17.85h0l-.56.44h0c-.37.3-.74.61-1.1.93h0l-.54.49h0l-.52.5h0l-.52.51c1.25-.49,2.58-1.05,4.06-1.66",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M228.69,48.36v0Z",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M231.58,58.72a18.76,18.76,0,0,1,2-4.76,23.4,23.4,0,0,1,3.83-4,20.37,20.37,0,0,0,4.22-4.54,26.06,26.06,0,0,0,1.28-2.94c.33-.84.68-1.75,1.12-2.73l-15.39,9a31,31,0,0,0-.37,4.75,30.23,30.23,0,0,0,1.92,10.63c.27-1.33.69-3.12,1.26-5,0-.15.1-.31.15-.49",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M244.57,32.33a25.92,25.92,0,0,0-3.77,1.36A18.28,18.28,0,0,1,236.68,35c-.74.14-1.55.25-2.4.35a30.18,30.18,0,0,0-5.59,13l18.23-16.6c-.76.17-1.57.36-2.35.57",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M235,34.51c.55-.08,1.08-.16,1.58-.25a18.13,18.13,0,0,0,4-1.3,25.81,25.81,0,0,1,3.88-1.39c1.21-.33,2.49-.62,3.54-.84a10.74,10.74,0,0,1-.58-1.18l-1.39-.24a24.73,24.73,0,0,0-2.85,1l-1.9.8c-1.87.78-3.52,1.47-5,2-.2.22-.4.45-.59.68l0,0c-.17.2-.35.41-.52.63l0,0",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M282.94,35.38c-.84-.09-1.64-.2-2.37-.34a18.44,18.44,0,0,1-4.12-1.35,25.92,25.92,0,0,0-3.77-1.36c-.76-.2-1.55-.39-2.29-.56l18.13,16.51a30.31,30.31,0,0,0-5.58-12.9",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M276.76,33a18.13,18.13,0,0,0,3.95,1.3c.49.09,1,.17,1.55.24h0l-.59-.7h0c-.2-.24-.4-.47-.61-.7-1.5-.55-3.14-1.24-5-2l-1.9-.8a25.79,25.79,0,0,0-2.66-.92l-1.54.26a9,9,0,0,1-.56,1.12c1.05.23,2.3.51,3.49.83A26.06,26.06,0,0,1,276.76,33",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M272.61,29.18c.55.18,1.13.39,1.74.64l1.9.79c1.46.61,2.78,1.17,4,1.65h0l-.5-.49h0l-.49-.48h0l-.51-.46h0l-.52-.45,0,0-.52-.43,0,0-.54-.42h0c-.18-.14-.36-.28-.55-.41h0c-.18-.14-.37-.27-.57-.41h0Z",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M283.64,44.9l-15.7-12.2c-.1.11-.21.22-.32.32s-.21.21-.32.31l16.58,11.75Z",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M261.91,36.13l-.42.1L267,52.59l.06,0,.15.06L262.39,36l-.48.12",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M250.23,52.59l5.53-16.38-.49-.11-.42-.12L250,52.67l.06,0,.15,0",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M249.69,33l-.32-.32L233.71,44.85l-.32.26L250,33.32l-.33-.31",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M270.67,26.38q0,.42-.06.84l2.92-.12-.72-.4h0l-.74-.38Z",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M246.72,27.23c0-.28-.06-.56-.07-.85l-1.47-.07-.74.38h0l-.73.4Z",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M267.62,77.42a11,11,0,0,0-3.88-.76,10.15,10.15,0,0,0-4.87,1.23v.64a12,12,0,0,1,5.19-1.16,12.78,12.78,0,0,1,4,.74,12.42,12.42,0,0,0,4,.73c2.24,0,3-.33,3.22-.46,0-.17,0-.44,0-.88V74.87c0-2.18,0-5.08,0-8,0-4.91,0-9.83,0-11.21a6.31,6.31,0,0,1-.7.21c0,8.06,0,20.84,0,21.37a.25.25,0,0,1,0,.19c-.09.11-.67.68-3.47.68a9.6,9.6,0,0,1-3.45-.71",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M261.4,79.61a.65.65,0,0,1,.17.5.82.82,0,0,1-.78.82h-4.35a.81.81,0,0,1-.77-.82.67.67,0,0,1,.16-.5l-11.13.92a30.39,30.39,0,0,0,27.82,0Z",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M250.23,41.3a20.07,20.07,0,0,0-2.17,4.16,14.12,14.12,0,0,1-2.52,4.44A16.39,16.39,0,0,1,239.69,54a10.18,10.18,0,0,0-3.09,1.88c-1.88,1.73-3.73,5.75-5.09,8.69l-.63,1.37a30.44,30.44,0,0,0,9.91,12.2V56.49h.66V55.3a.26.26,0,0,1,.13-.22.28.28,0,0,1,.25,0,3.49,3.49,0,0,0,.82.29V54.09a.25.25,0,0,1,.18-.24.25.25,0,0,1,.27.09,1.67,1.67,0,0,0,.79.29H244V52.89a.25.25,0,0,1,.17-.24.25.25,0,0,1,.28.09h0s.5.48,2.86.48a6.54,6.54,0,0,0,1.43-.15l2.75-13.32c-.48.53-.93,1.06-1.3,1.55",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M253.5,76.66a11,11,0,0,0-3.88.76,9.66,9.66,0,0,1-3.46.71c-2.79,0-3.37-.57-3.46-.68a.25.25,0,0,1,0-.19c0-.53,0-13.31,0-21.37a7,7,0,0,1-.7-.21c0,1.38,0,6.3,0,11.21v8c0,1.09,0,2,0,2.63,0,.44,0,.71,0,.88a6.89,6.89,0,0,0,3.22.46,12.42,12.42,0,0,0,4-.73,12.83,12.83,0,0,1,4-.74,12,12,0,0,1,5.2,1.16v-.64a10.19,10.19,0,0,0-4.87-1.23",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M267.18,76a9.25,9.25,0,0,0-3.41-.64,11,11,0,0,0-4.91,1.18s0,0,0,.05v.78a10.68,10.68,0,0,1,4.87-1.16,11.25,11.25,0,0,1,4,.79,9.33,9.33,0,0,0,3.29.68,6.28,6.28,0,0,0,3-.45c0-.17,0-.45,0-.88,0-.64,0-1.55,0-2.63v-8c0-4.85,0-9.7,0-11.16a3.43,3.43,0,0,1-.67.2h-.23c0,7.94,0,20.42,0,20.93a.29.29,0,0,1,0,.13c-.07.17-.49.74-3.09.74a7.9,7.9,0,0,1-2.91-.58",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M250.06,76a7.9,7.9,0,0,1-2.91.58c-2.61,0-3-.57-3.09-.74a.2.2,0,0,1,0-.13c0-.51,0-13,0-20.93h-.23a3.43,3.43,0,0,1-.67-.2c0,1.46,0,6.31,0,11.16,0,2.9,0,5.8,0,8V76.3c0,.44,0,.71,0,.88a6.24,6.24,0,0,0,3,.45,9.43,9.43,0,0,0,3.3-.68,11.2,11.2,0,0,1,4-.79,10.75,10.75,0,0,1,4.87,1.16v-.78a.09.09,0,0,1,0-.05,11.11,11.11,0,0,0-4.92-1.18,9.23,9.23,0,0,0-3.4.64",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M263.41,52.25a8.88,8.88,0,0,0-4.65,1.29.28.28,0,0,1-.28,0,8.93,8.93,0,0,0-4.66-1.29,7.44,7.44,0,0,0-3.25.73,7.46,7.46,0,0,1-3.22.74,7.6,7.6,0,0,1-2.81-.38c0,1.45,0,6.2,0,11v7.84c0,1.07,0,2,0,2.58,0,.45,0,.73,0,.9s.66.42,2.61.42a7.56,7.56,0,0,0,2.74-.55,9.54,9.54,0,0,1,3.57-.67,11.52,11.52,0,0,1,5.16,1.24,11.42,11.42,0,0,1,5.15-1.24,9.54,9.54,0,0,1,3.57.67,7.61,7.61,0,0,0,2.75.55c2,0,2.49-.33,2.61-.42s0-.45,0-.9V64.29c0-4.75,0-9.5,0-11a7.53,7.53,0,0,1-2.8.38,7.46,7.46,0,0,1-3.22-.74,7.45,7.45,0,0,0-3.26-.73M253.14,63c.93-.06,1-.14,1-1.21V58.31c0-1.07-.09-1.15-1-1.21v-.27h3.35v.27c-.9.06-1,.14-1,1.21v3.46c0,1.07.1,1.15,1,1.21v.28h-3.35Zm-6.32.28V63c.88-.06,1-.14,1-1.21V58.31c0-1.07-.1-1.15-1-1.21v-.27h5.37c0,.15.08.89.15,1.46l-.36,0a1.66,1.66,0,0,0-.44-.88c-.2-.17-.58-.23-1.32-.23h-.62c-.45,0-.47,0-.47.36v2.19h1.19c1,0,1-.05,1.16-.79h.38v2h-.38c-.12-.74-.14-.78-1.16-.78h-1.19v1.54c0,1.07.09,1.15,1.19,1.21v.28ZM253.11,72h-5.57v-.28c1-.06,1.09-.14,1.09-1.21V67.06c0-1.07-.1-1.15-1-1.21v-.28H251v.28c-.95.06-1,.14-1,1.21V70.5c0,.58.07.85.27,1a2.28,2.28,0,0,0,1,.14,2.14,2.14,0,0,0,1.36-.29,2.61,2.61,0,0,0,.59-1l.38.06c-.07.32-.34,1.33-.43,1.63m8.41-6.16c-.6,0-.91.16-1,.51a14.46,14.46,0,0,0-.1,2v.71a3,3,0,0,1-.87,2.36,3.34,3.34,0,0,1-2.2.74,3.73,3.73,0,0,1-2.11-.52,2.51,2.51,0,0,1-.89-2.31V67c0-1.07-.1-1.13-1-1.19v-.28h3.35v.28c-.88.06-1,.12-1,1.19v2.08c0,1.58.61,2.46,2,2.46s2.15-.91,2.15-2.64v-.6a12.35,12.35,0,0,0-.11-2c-.06-.35-.39-.47-1.15-.51v-.28h2.9Zm.7-3.44c-.12-.3-.41-.91-.66-1.43h-2.19c-.16.3-.37.85-.54,1.27s-.12.65.41.7l.33,0v.28h-2.64V63c.74-.08.87-.12,1.28-1l2.4-5.14.48-.12.82,1.84c.53,1.21,1.06,2.43,1.51,3.42s.57,1,1.26,1v.28h-3.13V63l.34,0c.45-.06.47-.16.33-.53M270,72H266.5v-.28l.34,0c.45,0,.46-.16.28-.44s-.5-.69-1.5-2c-.61.76-1.21,1.71-1.37,1.94s-.24.48.21.5l.45,0V72H262v-.28a1.72,1.72,0,0,0,1.29-.46c.23-.23,1.33-1.52,2-2.41l-1.69-2.22a1.5,1.5,0,0,0-1.43-.79v-.28h3.28v.28l-.38,0c-.38,0-.47.12-.28.35s.71,1,1.29,1.72a19.82,19.82,0,0,0,1.21-1.64c.19-.29.19-.39-.23-.43l-.41,0v-.28h2.77v.28a1.67,1.67,0,0,0-1.47.68c-.36.38-.93,1-1.55,1.79l2,2.62a1.55,1.55,0,0,0,1.5.79Zm0-15.18a.62.62,0,0,0,.57-.26h.19c0,.41.07,1.17.14,1.8l-.36,0a1.58,1.58,0,0,0-.44-.92c-.2-.19-.58-.25-1.32-.25h-.61v4.55c0,1.07.09,1.15,1.18,1.21v.28h-3.65V63c1-.06,1.14-.14,1.14-1.21V57.22h-.41c-1,0-1.33.12-1.52.3a2.12,2.12,0,0,0-.43.87h-.35c0-.65.12-1.31.14-1.82h.21c.17.24.29.26.62.26Z",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "260.42 49.37 259.5 51.55 261.39 51.55 260.46 49.37 260.42 49.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M247.48,26.06c0,5.31,5,9.62,11.18,9.62s11.18-4.31,11.18-9.62a6.28,6.28,0,0,0,0-.75h0l-.52-.2-.15-.05-.47-.17-.21-.08-.44-.14-.25-.08-.42-.13-.27-.08-.42-.12-.29-.08-.4-.1-.31-.08-.4-.09-.32-.07-.39-.08-.33-.06-.39-.07-.35-.06-.37-.06-.37-.05-.37-.05-.38,0-.36,0-.4,0-.34,0-.44,0-.31,0-.5,0h-2l-.5,0-.31,0-.44,0-.33,0-.41,0-.34,0-.4,0-.35.05-.38.05-.36,0-.36.07-.37.06-.35.07-.37.07-.34.08-.37.08-.33.08-.38.1-.31.08-.39.11-.29.08-.41.13-.23.08-.45.14h0c-.44.14-.87.3-1.29.47h0a6.84,6.84,0,0,0-.05.79",
    transform: "translate(0 -8.98)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M258.61,10A43.57,43.57,0,1,1,215,53.54,43.57,43.57,0,0,1,258.61,10m0-1A44.39,44.39,0,1,0,276,12.48,44.33,44.33,0,0,0,258.61,9",
    transform: "translate(0 -8.98)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped_1_2_3_4",
    "data-name": "Clipped 1, 2, 3, 4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clipped_2_and_3",
    "data-name": "Clipped 2 and 3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Taper3"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 255.54,
    y1: 26.69,
    x2: 249,
    y2: 47.24
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "256.11 26.87 249 47.24 254.98 26.51 256.11 26.87"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Taper2"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 262.01,
    y1: 26.94,
    x2: 268.35,
    y2: 47.55
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "262.58 26.77 268.35 47.55 261.44 27.12 262.58 26.77"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Taper4"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 250.32,
    y1: 23.63,
    x2: 233.21,
    y2: 36.3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "250.67 24.1 233.21 36.3 249.97 23.15 250.67 24.1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Taper1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 267.18,
    y1: 23.54,
    x2: 284.1,
    y2: 36.26
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "267.54 23.07 284.1 36.26 266.83 24.02 267.54 23.07"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M220,51.59a2.1,2.1,0,0,0-1.52,2.35,2.79,2.79,0,0,0,3.1,2.8c2-.06,3.27-1.28,3.21-3a2.75,2.75,0,0,0-1.82-2.55l.06-.47a14.08,14.08,0,0,1,1.86.6,13.22,13.22,0,0,1,.38,2.39c.11,3.43-1.66,4.85-3.38,4.9-2.11.07-3.8-1.86-3.9-4.89a11.26,11.26,0,0,1,.2-2.32c.59-.13,1.06-.19,1.73-.29Z",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M223.9,46.63c.77.16,1,.16,1.16-.09a3.15,3.15,0,0,0,.28-.92,2.29,2.29,0,0,0,0-1.43,3.3,3.3,0,0,0-.91-.82l.17-.43a14.31,14.31,0,0,1,1.66.81l-1.25,6-.34-.07c.15-1,.1-1.16-1-1.4l-3.6-.75c-1.13-.24-1.23-.16-1.49.79l-.34-.07.79-3.77.34.07c-.14,1-.09,1.11,1,1.34Z",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M228.29,38.3l.1-.32c.16-.46.08-.56-.42-.57l-1.44,0-1,2c.21.27.57.63.91,1s.51.43.82-.08l.17-.27.31.15-1.26,2.61-.31-.15c.26-.72.29-.9-.38-1.72L222,36.24l.14-.64,2.16.1c1.38.07,2.78.11,4,.14s1.24-.13,1.59-.72l.31.15-1.52,3.17Zm-3.16.74.81-1.69-2.39-.12,0,0Z",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M230.81,31.74c.89.74,1,.71,1.67,0l.26.22-2.39,2.87-.26-.22c.57-.79.58-.92-.31-1.66L227,30.61c-.89-.74-1-.71-1.66,0l-.26-.22,2.23-2.67A5,5,0,0,1,229,26.15a1.53,1.53,0,0,1,1.61.23,2,2,0,0,1,.32,2.43c.35.06,1.22.15,1.84.19a15.28,15.28,0,0,0,1.58,0,1.7,1.7,0,0,0,.83-.3l.23.23-.32.34c-1.06,1.15-1.55,1.31-2.35,1.3a14.19,14.19,0,0,1-2-.25.72.72,0,0,0-.82.32l-.19.23Zm-1.36-1.14.24-.28a2.06,2.06,0,0,0,.54-1.09,1.54,1.54,0,0,0-.6-1.4,1.46,1.46,0,0,0-2.14.3c-.39.47-.39.52-.06.79Z",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M237.11,25.75c.65.95.8.94,1.64.41l.2.28-3,2.18-.2-.28c.7-.59.74-.71.06-1.65l-2.15-3c-.67-.94-.8-.94-1.63-.43l-.2-.27,3-2.18.2.28c-.72.59-.76.71-.08,1.65l1,1.43c.2-.75.67-2.85.75-3.61.06-.53,0-.6-.3-.43l-.42.25-.21-.27,2.66-1.92.2.28a2.65,2.65,0,0,0-1.07,1.7c-.29,1-.55,1.87-.74,2.71,1.34.28,2.71.55,4,.75.87.11,1.12.1,1.58-.16l.2.27-2,1.48c-.68-.18-3-.65-4.52-1l0,0Z",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M246.26,15l.1.33c-.87.33-1,.44-.6,1.54L246.4,19c.5,1.6,1.39,2.28,2.73,1.87s1.84-1.57,1.3-3.33l-.21-.67a13.13,13.13,0,0,0-.72-1.92c-.17-.33-.52-.37-1.34-.15l-.1-.33,3-.94.1.33c-.6.21-.85.44-.8.82a10.86,10.86,0,0,0,.48,2l.22.75a3.27,3.27,0,0,1-.1,2.76A3.68,3.68,0,0,1,249,21.63a4.18,4.18,0,0,1-2.41.14c-.79-.24-1.3-.89-1.67-2.09l-.71-2.31c-.34-1.1-.46-1.14-1.41-.92l-.1-.32Z",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M261,20l-.78,0L255,15h0l.07,2.22a13.27,13.27,0,0,0,.2,2c.07.37.4.5,1.25.5v.34l-3.18.11,0-.34c.65-.05.95-.21,1-.58a12.56,12.56,0,0,0,.06-2.05l-.07-2.12c0-.68,0-.94-.27-1.19a1.49,1.49,0,0,0-1.1-.33v-.34l2.23-.07,5.12,4.65h0l-.06-1.88a11.91,11.91,0,0,0-.2-2c-.07-.37-.4-.5-1.25-.51V13l3.19-.1v.34c-.64,0-1,.2-1,.58a12.35,12.35,0,0,0-.06,2Z",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M265.9,19.1c-.2,1.14-.12,1.23.81,1.47l-.06.33-3.72-.67.06-.34c.95.11,1.06.05,1.27-1.09l.66-3.62c.21-1.14.12-1.23-.8-1.46l.06-.34,3.71.68-.06.34c-.95-.11-1.06-.06-1.27,1.08Z",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M270.36,22.16c-.15-2.12-.34-5-.41-6.13s-.26-1.22-.88-1.53l.13-.32,3.45,1.33-.12.32-.43-.12c-.46-.12-.53,0-.52.43,0,.65.19,3,.3,4.59.75-.72,2.53-2.64,2.9-3,.54-.57.49-.72,0-1l-.35-.17.12-.32,2.83,1.08-.12.32c-.77-.21-.92-.21-1.8.57-.13.12-2.76,2.51-4.44,4.21Z",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M278,19.71c.63-1,.58-1.09-.16-1.65l.18-.28,5,3.18c-.09.16-.45.85-.78,1.48l-.41-.22a1.77,1.77,0,0,0,.13-1.08c-.08-.26-.4-.55-1-.95l-.42-.28c-.41-.26-.43-.27-.63,0L278.6,21.8l.79.51c.93.59,1,.57,1.56-.07l.39.25-1.27,2-.39-.25c.35-.78.35-.85-.58-1.44l-.79-.51-.91,1.41c-.42.66-.5.88-.33,1.11a3.5,3.5,0,0,0,.87.66,2.44,2.44,0,0,0,1.41.53,2.88,2.88,0,0,0,1.1-.57l.35.32A15.43,15.43,0,0,1,279.45,27l-5.34-3.43.19-.29c.92.52,1.05.51,1.67-.46Z",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M283.42,28.44c-.84.81-.82.93-.2,1.66l-.25.24-2.59-2.69.24-.24c.73.66.85.68,1.68-.12L285,24.73c.84-.8.82-.92.23-1.64l.24-.23,2.42,2.5a5.12,5.12,0,0,1,1.33,1.91,1.54,1.54,0,0,1-.41,1.57,1.94,1.94,0,0,1-2.45.06c-.09.34-.28,1.2-.38,1.81a11.91,11.91,0,0,0-.17,1.57,1.63,1.63,0,0,0,.21.85l-.25.21-.3-.35c-1-1.18-1.14-1.69-1-2.48a14.23,14.23,0,0,1,.46-2,.72.72,0,0,0-.22-.85l-.21-.21Zm1.28-1.23.25.27a2,2,0,0,0,1,.66,1.55,1.55,0,0,0,1.46-.45,1.45,1.45,0,0,0-.08-2.15c-.42-.44-.47-.44-.77-.15Z",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M288,33a2.56,2.56,0,0,0-.31,2.81,1.18,1.18,0,0,0,1.66.53c.62-.38.67-1,.46-2l-.06-.27c-.22-1.13-.17-2.23.69-2.76s2.35-.19,3.28,1.33a4.25,4.25,0,0,1,.5,1.08c.06.21.12.39.17.55-.3.24-.67.57-1.15,1l-.3-.36a1.8,1.8,0,0,0,.27-2.2,1.1,1.1,0,0,0-1.56-.5c-.47.28-.55.89-.34,1.85l.08.43c.23,1.06.25,2.17-.74,2.78s-2.52.15-3.49-1.43a5,5,0,0,1-.53-1.19c-.11-.36-.16-.61-.2-.79.19-.23.74-.75,1.21-1.21Z",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M291.79,41.31c-1.07.43-1.1.55-.81,1.46l-.32.13-1.4-3.51.31-.12c.42.85.53.92,1.6.49l3.42-1.37c1.07-.43,1.1-.55.81-1.46l.31-.12,1.41,3.5-.32.13c-.41-.86-.52-.93-1.59-.5Z",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M293.51,47.69c-1.14.22-1.19.34-1,1.48l-.34.07-.79-4.06.34-.07c.27,1.08.36,1.16,1.5.94l4.75-.93-.07-.31c-.19-1-.39-1.34-.6-1.49a2.13,2.13,0,0,0-1.06-.28l-.09-.45c.76-.1,1.5-.16,2-.24l0,.24a.75.75,0,0,0-.12.74l1,5.07a.91.91,0,0,0,.4.64l.05.24c-.44.1-1.25.32-1.95.52l-.12-.44a1.89,1.89,0,0,0,.94-.67,2.31,2.31,0,0,0,0-1.41l-.1-.52Z",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M293.77,55.36c-1.15,0-1.23.07-1.32,1.2h-.35l.1-4.08h.35c0,1.08.11,1.18,1.26,1.21l1,0a1,1,0,0,0,.61-.16c.63-.33,1.32-.79,2.56-1.58.81-.52.83-.61.91-1.26h.34l-.09,3.54h-.34l0-.53c0-.32-.11-.35-.46-.15-.83.48-1.66,1-2.46,1.46.61.42,1.64,1,2.33,1.41.41.23.49.17.55-.29l.05-.49h.35l-.08,3h-.34c-.05-.8-.14-.91-.86-1.47a20.35,20.35,0,0,0-2.09-1.5,1.21,1.21,0,0,0-.86-.28Z",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M232.32,75.6l-.24.16c-.53-.69-.58-.7-1.41-.13l-2.6,1.82c-.84.58-.85.62-.44,1.38l-.24.16-1.72-2.65.24-.16c.5.65.54.66,1.4.09l2.87-1.9,0,0-5.29.57-.2-.31,2.52-4.42v0l-2,1.16a10.32,10.32,0,0,0-1.31.89c-.26.23-.2.47.15,1.09l-.25.16-1.42-2.19.24-.16c.32.42.51.54.83.41a13.93,13.93,0,0,0,1.51-.75l1.64-.9c1.07-.59,1.11-.72.66-1.52l.25-.16,1.21,1.86-2.25,4.14,4.63-.47Z",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M235.2,78.6a5.11,5.11,0,0,1,1.52,2.86,2.46,2.46,0,0,1-.76,2c-1.66,1.54-3.8.67-5.56-1.23l-1.9-2.06.22-.2c.62.6.73.62,1.46-.06l2.33-2.14c.73-.68.71-.79.23-1.39l.22-.2Zm-4,2.33c-.62.58-.69.79-.15,1.38a2.41,2.41,0,0,0,3.64.14c1.45-1.34,1.09-2.64,0-3.8a2.19,2.19,0,0,0-.47-.42c-.07,0-.22.1-.4.27Z",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M242.79,85.9a1.81,1.81,0,0,0-1.07-2.15,2.41,2.41,0,0,0-3.44,1.06,2.53,2.53,0,0,0,.8,3.68,2.37,2.37,0,0,0,2.68-.22l.32.25a13,13,0,0,1-1.26,1.11,11.1,11.1,0,0,1-1.93-.77c-2.59-1.42-2.86-3.36-2.14-4.66.88-1.59,3.05-2,5.33-.72a9,9,0,0,1,1.63,1.17c-.17.48-.32.86-.55,1.4Z",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M249.6,88.49a1.8,1.8,0,0,0-1.47-1.9A2.41,2.41,0,0,0,245,88.31c-.51,1.63.11,3,1.51,3.45a2.38,2.38,0,0,0,2.59-.75l.36.18a12.6,12.6,0,0,1-1,1.34,11.4,11.4,0,0,1-2-.37c-2.82-.88-3.47-2.72-3-4.14.54-1.73,2.59-2.55,5.08-1.77a10.11,10.11,0,0,1,1.83.82c-.07.51-.15.91-.26,1.48Z",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M257,89.66a1.8,1.8,0,0,0-1.79-1.6,2.39,2.39,0,0,0-2.8,2.25,2.53,2.53,0,0,0,2.1,3.13,2.38,2.38,0,0,0,2.41-1.2l.38.12a11.63,11.63,0,0,1-.75,1.5,12,12,0,0,1-2.08,0c-2.93-.37-3.9-2.07-3.71-3.54.23-1.8,2.1-3,4.69-2.64a10.33,10.33,0,0,1,1.94.48c0,.52,0,.93,0,1.51Z",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M260.76,92.42c0,.67.09.87.33.94a2.66,2.66,0,0,0,.83,0A2,2,0,0,0,263.1,93a2.78,2.78,0,0,0,.47-.94l.4,0a13.87,13.87,0,0,1-.29,1.57l-5.26.31,0-.3c.9-.1,1-.17.93-1.17l-.19-3.16c-.06-1-.15-1-1-1.06l0-.29,3.31-.19,0,.29c-.86.11-.94.18-.89,1.17Z",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M268.76,92.36l.29-.1c.4-.15.39-.26.13-.49l-1.64-1.37c-.33.72-.63,1.62-.74,1.92s-.15.48.28.41l.4-.06.07.29-2.69.66-.07-.28c.57-.19.83-.3,1-.65s.89-1.69,1.31-2.6l-2.07-1.66a1.34,1.34,0,0,0-1.42-.37l-.08-.28,3.16-.78.07.28-.34.12c-.33.12-.35.18-.17.35s.84.75,1.46,1.21a18,18,0,0,0,.69-1.67c.11-.29.11-.36-.29-.3l-.38.05-.07-.28,2.57-.64.07.29a1.59,1.59,0,0,0-1.19.91c-.27.46-.67,1.17-1,1.92l2.47,1.94a1.35,1.35,0,0,0,1.47.36l.07.28-3.31.82Z",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M276.31,89.56l.27-.15c.36-.23.33-.34,0-.51l-1.89-1a20.2,20.2,0,0,0-.33,2c0,.23-.06.51.35.35l.38-.14.13.27-2.5,1.19-.13-.26c.52-.3.75-.46.89-.85s.53-1.83.76-2.81l-2.37-1.2a1.32,1.32,0,0,0-1.46-.08l-.13-.26,2.93-1.4.13.26-.31.19c-.3.18-.31.24-.1.37s1,.56,1.67.89c.12-.49.26-1.18.35-1.77,0-.31,0-.38-.35-.24l-.36.13-.12-.27,2.38-1.14.13.27c-.64.38-.75.46-1,1.13-.17.51-.43,1.29-.62,2.09l2.81,1.4a1.38,1.38,0,0,0,1.52,0l.13.27-3.08,1.47Z",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M283.14,85.31l.23-.21c.31-.29.26-.39-.07-.5l-2.05-.6c0,.78.06,1.73.08,2s.05.5.41.27l.35-.22.18.24L280.06,88l-.18-.24c.45-.39.64-.59.7-1s.15-1.9.18-2.9l-2.56-.71a1.32,1.32,0,0,0-1.45.22l-.18-.23,2.59-2,.18.23-.26.24c-.26.25-.26.3,0,.39s1.07.36,1.81.53c0-.5,0-1.2,0-1.8,0-.31,0-.38-.39-.16l-.32.19-.18-.23L282.07,79l.18.23a1.58,1.58,0,0,0-.73,1.3c-.07.54-.16,1.35-.19,2.18l3,.8a1.35,1.35,0,0,0,1.49-.25l.18.23-2.72,2.06Z",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M288.73,80.61l-5.07-1.51c-.89-.27-1.06-.16-1.49.24l-.22-.19,2.11-2.39.22.2-.22.3c-.24.34-.2.42.19.55s2.45.74,3.78,1.14c-.36-.82-1.37-2.83-1.57-3.25-.31-.61-.44-.61-.8-.27l-.24.23-.22-.19,1.72-2,.22.19c-.4.56-.45.68-.08,1.62.05.14,1.2,3,2.06,4.84Z",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M291.93,73.85c.84.53.95.49,1.43-.17l.25.16-1.74,2.74-.25-.15c.39-.72.38-.83-.46-1.37l-2.67-1.69c-.84-.54-.94-.5-1.43.16l-.24-.15,1.74-2.75.25.16c-.4.72-.39.83.45,1.36Z",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M294,70.1c.89.43,1,.38,1.4-.33l.26.13-1.43,2.92-.26-.13c.31-.76.29-.87-.6-1.3L290.47,70c-.89-.44-1-.39-1.4.32l-.26-.13,1.43-2.91.26.13c-.31.76-.29.86.6,1.3Z",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M223.76,66.54a8.91,8.91,0,0,0-.67-.73,1.9,1.9,0,0,0-1.11-.57,8.07,8.07,0,0,0-1-.13l0-.12a7.39,7.39,0,0,0,.73-.69,2.13,2.13,0,0,0,.38-.5,2.42,2.42,0,0,0,.2-.61,8.16,8.16,0,0,0,.12-1l.12,0a8.88,8.88,0,0,0,.68.73,2.13,2.13,0,0,0,.5.38,2.5,2.5,0,0,0,.6.19,8,8,0,0,0,1,.13l0,.13a7.71,7.71,0,0,0-.74.68,1.83,1.83,0,0,0-.57,1.11c0,.25-.09.57-.13,1Z",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M295.47,61.46c0,.41.1.73.15,1a2.58,2.58,0,0,0,.21.6,3,3,0,0,0,.39.5,8.77,8.77,0,0,0,.76.66l0,.12a9.35,9.35,0,0,0-1,.16,2.58,2.58,0,0,0-.6.21,2.45,2.45,0,0,0-.5.39c-.18.18-.39.43-.65.75l-.12,0a7.36,7.36,0,0,0-.15-1,2.58,2.58,0,0,0-.21-.6,2.18,2.18,0,0,0-.39-.49,9.9,9.9,0,0,0-.75-.67l0-.12q.63-.07,1-.15a2.58,2.58,0,0,0,.6-.21,3,3,0,0,0,.5-.39,8.36,8.36,0,0,0,.65-.75Z",
    transform: "translate(0 -8.98)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M37.24,33.08c-2-7.78-6.36-9.87-13-9.87C12.1,23.21,6.69,32.4,6.69,43c0,13,6.69,21.69,17.64,21.69,7.57,0,11.08-3.65,14.39-10.74l1.69.2C39.53,57.07,38.05,62.47,37,65a61.05,61.05,0,0,1-12.71,1.89C7.16,66.93,0,55.31,0,44.56,0,30.64,10.75,21,25.54,21a50,50,0,0,1,12.17,1.76c.54,3.71.81,6.69,1.22,10.2Z",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M58.49,57.37c0,3.56.3,5.22,1.43,5.82s3.32.77,5.58.77c3,0,5.76-.3,7.07-1.72a17.7,17.7,0,0,0,2.85-5.82l1.48.18c-.3,1.66-1.6,7.72-2.08,9.32H48V64.55c5-.35,5.46-.77,5.46-7.24V35.93C53.5,29.46,53,29,48,28.68V27.32h16v1.36c-5.1.36-5.58.78-5.58,7.25Z",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M106.12,64.55l1.9-.23c2.2-.24,2.44-.89,1.84-2.74-.41-1.42-2.14-6-3.8-10.33H94c-.6,1.54-2.14,6.18-3,8.67-1.13,3.45-.6,4.22,2.07,4.46l1.79.17v1.37H82.19V64.55c3.86-.41,4.33-.77,6.41-6L100.84,27l1.36-.53,4.22,11.28c2.79,7.54,5.4,15.08,7.72,21.14,1.9,5,2.67,5.41,6.35,5.7v1.37H106.12ZM94.78,49h10.51l-5.23-14.6h-.12Z",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M137.71,57.31c0,6.47.48,6.89,5.35,7.24v1.37h-15.8V64.55c5-.35,5.47-.77,5.47-7.24V35.93c0-6.47-.48-6.89-5.23-7.25V27.32h15.08c3.8,0,7.19.53,9.39,2a8.65,8.65,0,0,1,3.92,7.6c0,4.93-3,8.43-7.84,10.39,1.07,1.78,3.5,5.88,5.28,8.49a56.15,56.15,0,0,0,5,6.54,7.74,7.74,0,0,0,4.45,3l-.11,1.12h-.84c-6.83-.18-8.9-2.25-11.16-5.52-1.84-2.67-4.34-7.06-6-9.86a3.81,3.81,0,0,0-3.74-2.13h-3.21Zm0-10.1h3.45c2.43,0,4.33-.29,5.94-1.6a9.58,9.58,0,0,0,3.44-7.84c0-6.23-4.51-8.73-9-8.73a10.32,10.32,0,0,0-3.32.3c-.36.12-.54.41-.54,1.6Z",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M179.4,46a164.85,164.85,0,0,0,14.2-14.85c1-1.25.83-2-.78-2.14l-2.43-.3V27.32H204.7v1.36c-3.68.36-5.17.66-9.09,4.28-2.13,1.9-6.71,6.24-11.4,11.11C189.5,50.3,196,57.43,198.58,60.16c3.27,3.38,4.34,4.1,7.07,4.39v1.37h-8.79C194,62.77,183.5,50.36,179.4,46.08V57.31c0,6.47.48,6.89,5.58,7.24v1.37H169.25V64.55c4.69-.35,5.16-.77,5.16-7.24V35.93c0-6.47-.47-6.89-5.46-7.25V27.32h15.74v1.36c-4.81.36-5.29.78-5.29,7.25Z",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M11,71.79v.75c-2,.16-2.21.32-2.21,3.23v5.67c0,4.27,1.4,6.66,4.57,6.66s4.87-2.47,4.87-7.17V79.31A43.27,43.27,0,0,0,18,73.94c-.14-1-.89-1.29-2.61-1.4v-.75H21.9v.75c-1.35,0-2,.43-2.18,1.4a41.23,41.23,0,0,0-.24,5.37v1.91c0,2.61-.49,4.84-2,6.43a6.88,6.88,0,0,1-5,2,7.45,7.45,0,0,1-4.78-1.42c-1.43-1.16-2-3.09-2-6.27v-6.2c0-2.91-.21-3.07-2.36-3.23v-.75Z",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M32.4,71.79,43.13,84.42h0V79.31a41.23,41.23,0,0,0-.24-5.37c-.13-1-.89-1.29-2.61-1.4v-.75h6.56v.75c-1.34,0-2,.43-2.17,1.4a40.43,40.43,0,0,0-.25,5.37V89.47H43.24L32.16,75.93h0v5.8a41.43,41.43,0,0,0,.24,5.38c.13,1,.89,1.29,2.61,1.4v.75H28.4v-.75c1.34-.06,2-.43,2.18-1.4a43.49,43.49,0,0,0,.24-5.38V76.46c0-3.11-.59-3.76-2.8-3.92v-.75Z",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M61.3,71.79v.75c-2,.16-2.26.38-2.26,3.28v9.41c0,2.9.21,3.11,2.26,3.28v.75H53.72v-.75c2.09-.17,2.31-.38,2.31-3.28V75.82c0-2.9-.22-3.12-2.31-3.28v-.75Z",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M74.9,71.79v.75l-.86.13C73,72.81,73,73,73.28,74c.54,1.67,2.64,7,4.28,11.19,1.07-2.88,3.33-9,3.82-10.43.56-1.72.32-2-.86-2.18l-.81-.08v-.75h6.1v.75c-1.72.21-1.83.4-3.06,2.9-.27.54-3.61,8.5-5.68,14H75.92c-1.83-4.84-4.38-11.45-5.4-14.14-.92-2.42-1.35-2.58-2.85-2.74v-.75Z",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M104.33,71.79c0,.43.16,2.42.32,4.08l-.8.06a5,5,0,0,0-1-2.45c-.46-.46-1.32-.62-3-.62H98.52c-1,0-1.07,0-1.07,1v5.7h2.31c2.31,0,2.36-.16,2.63-2.23h.86V83h-.86c-.27-2.13-.32-2.24-2.63-2.24H97.45v4.41c0,1.56.1,2.31.59,2.66a5.37,5.37,0,0,0,2.58.35c1.34,0,2.58-.1,3.14-.78a8.34,8.34,0,0,0,1.37-2.71l.81.16c-.11.91-.7,3.66-.91,4.41H91.91v-.75c2.31-.17,2.53-.38,2.53-3.28V75.82c0-2.9-.22-3.12-2.26-3.28v-.75Z",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M119.84,71.79a7.93,7.93,0,0,1,4.43.91A3.92,3.92,0,0,1,126,76.11a4.86,4.86,0,0,1-3.57,4.65c.43.76,1.48,2.64,2.34,3.85a28.49,28.49,0,0,0,2.23,3,3.76,3.76,0,0,0,1.85,1.24l-.1.7-1.13-.06c-2.93-.21-3.85-1-4.89-2.47-.86-1.24-1.75-3-2.53-4.35-.43-.76-.75-1-1.56-1h-.86v3.61c0,2.9.21,3.11,2.26,3.28v.75H112.5v-.75c2.15-.17,2.36-.38,2.36-3.28V75.82c0-2.9-.21-3.12-2.26-3.28v-.75Zm-2,8.92h1a3.8,3.8,0,0,0,2.53-.7,4.25,4.25,0,0,0,1.45-3.44,3.46,3.46,0,0,0-3.66-3.76c-1.29,0-1.34.11-1.34,1Z",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M144.7,75.9c-.49-1.56-1.32-3.44-3.58-3.44a2.64,2.64,0,0,0-2.74,2.82c0,1.51,1.08,2.5,3.15,3.44l.69.32c2.1.95,4,2.37,4,5.16,0,3.2-2.5,5.46-6.13,5.46a8.28,8.28,0,0,1-2.69-.46c-.75-.24-1.24-.45-1.56-.56-.21-.7-.54-2.53-.81-4.17l.81-.27c.54,1.4,2,4.39,4.76,4.39a2.82,2.82,0,0,0,2.82-3c0-1.51-.72-2.58-2.85-3.63l-.86-.43c-1.77-.91-4-2.34-4-5,0-2.83,2.12-5.14,5.73-5.14a7.8,7.8,0,0,1,2.44.38c.43.16.81.21,1.13.35.11.94.27,2.12.54,3.63Z",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M161.09,71.79v.75c-2,.16-2.26.38-2.26,3.28v9.41c0,2.9.22,3.11,2.26,3.28v.75h-7.58v-.75c2.1-.17,2.31-.38,2.31-3.28V75.82c0-2.9-.21-3.12-2.31-3.28v-.75Z",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M168.08,76c.11-1.77.27-3.54.32-4.94h.49c.37.64.64.7,1.39.7h11.08c.7,0,.86-.17,1.29-.7h.43c0,1.13.16,3.17.32,4.89l-.81,0a4.73,4.73,0,0,0-1-2.5c-.46-.51-1.32-.67-3-.67h-1.4V85.23c0,2.9.21,3.11,2.69,3.28v.75h-8.28v-.75c2.36-.17,2.58-.38,2.58-3.28V72.86h-.92c-2.31,0-3,.32-3.44.81a5.92,5.92,0,0,0-1,2.36Z",
    transform: "translate(0 -8.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M196.27,71.79v.75l-1.13.16c-.69.11-.75.32-.32,1.18.65,1.29,2.37,4.55,3.47,6.32.83-1.43,2.31-4.33,3.12-6.16.46-1,.29-1.29-.65-1.39l-1.07-.11v-.75h6.05v.75c-1.62.16-1.86.48-3,2.26-1,1.61-2,3.28-3.38,5.94a2.55,2.55,0,0,0-.35,1.61v2.88c0,2.9.21,3.11,2.63,3.28v.75h-8.17v-.75c2.31-.17,2.53-.38,2.53-3.28V82.62a2.23,2.23,0,0,0-.38-1.45c-.86-1.62-1.83-3.31-3.6-6.37-1.16-2-1.29-2.1-2.69-2.26v-.75Z",
    transform: "translate(0 -8.98)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogo);
export default __webpack_public_path__ + "static/media/footer-logo.b9e9b281029da10a3ace01e84b8dfff5.svg";
export { ForwardRef as ReactComponent };